module.exports = __webpack_public_path__ + "img/folder_plus.d722e235.svg";